module.exports = __webpack_public_path__ + "build/img/07.2ce2d72b.jpg";